<div class="option-select-div">
    <span class="option-select firt-span">Seja Bem-vindo!</span>
    <span class="option-select second-span">Como podemos ajudar?</span>
</div>
<div [ngClass]="{'custom-list-two-columns': listTotemButton.length >= 5, 'custom-list-simple': listTotemButton.length < 5}">
    <button mat-flat-button (click)="selectOption(totemButton.idTotemButton)" color="primary" class="btn-block" *ngFor="let totemButton of listTotemButton">
        <span>{{totemButton.totemButtonName}}</span>
    </button>
</div>